import { render, staticRenderFns } from "./CenteredLayout.vue?vue&type=template&id=beb7d9c0"
import script from "./CenteredLayout.vue?vue&type=script&lang=ts"
export * from "./CenteredLayout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports